import { defineAction } from "../classes/ActionDefinition";
export default defineAction({
    name: 'System.HelloWorld',
    async execute(data, params) {
        //Data
        appHost.notification.showToast("Hello World", "warning");
        return this.Ok();
    }
});
